import { gtag } from './analytics.js';

function sanitizeInput(value) {
	const sanitizer = document.createElement('div');
	sanitizer.innerHTML = value;
	return sanitizer.textContent;
}

function isFormValid(subscribeForm) {
	let valid = true;
	for (let element of subscribeForm.elements) {
		if (element.value) {
			let sanitizedValue = sanitizeInput(element.value);
			element.value = sanitizedValue;
			if (element.validity && !element.validity.valid) {
				valid = false;
			}
		}
	}
	return valid;
}

function getSanitizedFormDataAsJson(subscribeForm) {
	let formData = new FormData(subscribeForm);
	// https://stackoverflow.com/questions/41431322/how-to-convert-formdatahtml5-object-to-json
	// let object = {};
	// formData.forEach((value, key) => (object[key] = sanitizeInput(value)));
	// return JSON.stringify(object);
	return JSON.stringify(Object.fromEntries(formData.entries()));
}

async function processForm(subscribeForm) {
	// we have a valid form
	console.log(
		`Email subscription: sending ${getSanitizedFormDataAsJson(subscribeForm)}`
	);
	let message =
		'Something went wrong, we’ll have a look at it. Try back later?';
	try {
		const endpoint =
			'production' != document.body.dataset.env
				? 'https://cors-anywhere.herokuapp.com/' + subscribeForm.action
				: subscribeForm.action;
		// this is not a basic no-cors request, because we're sending json
		const request = await fetch(endpoint, {
			method: 'post',
			headers: new Headers({
				'Content-Type': 'application/json; charset=utf-8',
			}),
			body: getSanitizedFormDataAsJson(subscribeForm),
		});
		const returnedJson = await request.json();
		if (request.ok) {
			// 200-299
			message = 'Thanks for subscribing!';
			gtag('event', 'sign_up', { method: 'subscribe form' });
			console.log(
				`Email subscription success: ${JSON.stringify(returnedJson)}`
			);
		} else {
			console.error(
				`Email subscription failure: ${JSON.stringify(returnedJson)}`
			);
		}
	} catch (error) {
		console.error(`Email subscription failure: ${error.stack}`);
		gtag('event', 'exception', { description: error.message });
	}
	// let go of the submit button
	subscribeForm.elements.submit.disabled = false;
	// render user message to dom
	subscribeForm.firstElementChild.innerHTML = `<p>${message}</p>`;
}

export function emailForms() {
	const subscribeForms = Array.from(
		document.querySelectorAll('form.subscribe')
	);
	// we don't have forms so bail
	if (0 == subscribeForms.length) return;
	subscribeForms.forEach((subscribeForm) => {
		// adding the required attribute to inputs when they receive focus
		let inputs = subscribeForm.getElementsByTagName('input');
		for (let input of inputs) {
			input.onfocus = function (event) {
				event.target.required = 'true';
			};
		}
		// listening for submit
		subscribeForm.addEventListener('submit', function (event) {
			subscribeForm.elements.submit.disabled = true;
			event.preventDefault();
			if (isFormValid(subscribeForm)) {
				// nailing down the form height for when we replace its contents
				// to prevent content jumping around
				subscribeForm.style.height = subscribeForm.clientHeight + 'px';
				processForm(subscribeForm);
			} else {
				subscribeForm.elements.submit.disabled = false;
			}
		});
	});
}
